import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function UsuariosYClientes() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>V. USUARIOS Y CLIENTES CORPORATIVOS</h4>
          <br></br>
          <p>Adquiere la calidad de Usuario y Cliente Corporativo quien cumpla con los siguientes requisitos:</p>
          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <li>
              <p>
                Debe ser una persona con capacidad legal para celebrar contratos, según las leyes vigentes en la República de Colombia. Los representantes legales de los Usuarios que sean menores de edad declaran expresamente que han autorizado a estos últimos su registro en las Plataformas, entendiéndose que son responsables por el uso de las mismas, por parte de los Usuarios menores de edad.
              </p>
            </li>
            <li>
              <p>
                Debe estar registrado como en cualquiera de las Plataformas donde desee contratar el servicio.
              </p>
            </li>
            <li>
              <p>
                Debe tener conocimiento de los presentes T&C, ya que la aceptación conlleva la forzosa e ineludible obligación de conocer las condiciones, limitaciones y responsabilidades del servicio. Mediante la aceptación de los presentes T&C, acuerda vincularse jurídicamente a estos, por lo cual se entiende que conoce las condiciones, limitaciones y responsabilidad del Servicio.
              </p>
            </li>
            <li>
              <p>
                Debe haber leído, comprendido y aceptado la Política de Tratamiento de Datos, lo que implica un consentimiento previo, expreso e informado del usuario sobre el tratamiento de los datos personales, los derechos que le asisten y los canales de atención disponibles para su ejercicio.
              </p>
            </li>
          </ol>
        </Col>
      </Row>
    </Container>
  );
}